import { removeTokenFromLocalStorage } from './jwtHelper';
import { motd } from './localStorageHelper';

/**
 * ogs out from the client side by removing the token from local storage
 * and reload the page afterwards.
 */
export function clearTokenAndReload() {
  removeTokenFromLocalStorage();
  motd.remove();
  window.location.reload();
}

/**
 * Logs out from the client side by removing the token from local storage
 * and navigates to the given url afterwards.
 */
export function clearTokenAndNavigate(url: string) {
  removeTokenFromLocalStorage();
  motd.remove();
  window.location.assign(url);
}
